import { Module } from "vuex";
import { StoreState } from "@/store/type";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { ICostCenterState } from "../types";

const costCenterModule: Module<ICostCenterState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default costCenterModule;
